import { AuthStatusProvider } from "helpers/useAuthStatus";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import { BreadcrumbsProvider } from "helpers/useBreadcrumbs";
import { keycloakConfig, initOptions } from "keycloak";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { App } from "./App";
import "./index.scss";
import { reportWebVitals } from "./reportWebVitals";

ReactDOM.render(
	<React.StrictMode>
		<Router>
			<ReactKeycloakProvider authClient={keycloakConfig} initOptions={initOptions}>
				<AuthStatusProvider>
					<BreadcrumbsProvider>
						<App />
					</BreadcrumbsProvider>
				</AuthStatusProvider>
			</ReactKeycloakProvider>
		</Router>
	</React.StrictMode>,
	document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
